import { styled, TextField } from "@mui/material";

export const MDTextFieldCalendar = styled(TextField, {
    shouldForwardProp: (prop) => prop !== 'darkMode',
})(({ darkMode }) => ({
    // Ícone do calendário (WebKit browsers)
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
        color: darkMode ? 'white' : 'initial',
        filter: darkMode
            ? 'invert(1)'
            : 'invert(1) brightness(0) sepia(0) saturate(0) hue-rotate(0deg)',
    },

    // Texto quando desabilitado
    '& input:disabled': {
        color: darkMode ? 'white' : undefined,
        WebkitTextFillColor: darkMode ? 'white' : undefined,
    },

    // Forçar altura compacta globalmente (espelhada nos Selects menores)
    '& .MuiInputBase-root': {
        height: '30px',
        padding: '0 8px',
        minHeight: '30px',
    },
    '& .MuiInputBase-input': {
        padding: '6px 8px',
        height: 'auto',
    },

    // Borda do campo desabilitado (quando dark mode)
    '& .MuiOutlinedInput-root.Mui-disabled': {
        '& fieldset': {
            borderColor: darkMode ? 'white' : undefined,
        },
    },

    // Label desabilitada
    '& label.Mui-disabled': {
        color: darkMode ? 'white' : undefined,
    },
}));
